import $ from 'jQuery';
import {throttle} from './lib';

export default function moving({el, minWidth}) {
    let movementStrength = 20,
        winHeight,
        winWidth,
        height,
        width,
        pageX,
        pageY,
        newvalueX = 0,
        newvalueY = 0,
        currentX = 0,
        currentY = 0,
        timerId,
        $el = $(el),
        $window = $(window),
        checkSizeWin = throttle(checkSizeWindow, 2000);

    minWidth = minWidth || 1244;

    $(document).ready(function () {
        checkSizeWindow();
        moveScene();
        $('.home-content').mousemove(mousemove);
    });

    $window.on('resize', throttle(checkSizeWindow, 500));

    function mousemove(e) {
        if (winWidth >= minWidth) {
            changePosition(e);
        }
    }

    function changePosition(e) {
        pageX = e.pageX - (winWidth / 2);
        pageY = e.pageY - (winHeight / 2);
        newvalueX = width * pageX * -1 - 10;
        newvalueY = height * pageY * -1 - 10;
        checkSizeWin();
        clearTimeout(timerId);
        moveScene();
    }

    function moveScene() {
        let deltaX = (newvalueX - currentX) / 10;
        let deltaY = (newvalueY - currentY) / 10;
        if (Math.abs(deltaX) >= 0.1 || Math.abs(deltaY) >= 0.1) {
            currentX += deltaX;
            currentY += deltaY;

            $el.css({'transform': `translate(${currentX}px, ${currentY}px`});
            timerId = setTimeout(moveScene, 40);
        }
    }

    function checkSizeWindow() {
        winHeight = $window.height();
        winWidth = $window.width();
        height = movementStrength / winHeight;
        width = movementStrength / winWidth;
    }
}


// WEBPACK FOOTER //
// ./modules/backgroundMoving.js